import React, { useEffect } from 'react';
import { SaveOutlined } from '@ant-design/icons';
import useTranslate from '@hooks/useTranslate';
import { NumericField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { Button, Col, Flex, Form, Row, Switch } from 'antd';

import './index.scss';


const KitplaySettingForm = ({
    formId,
    settingObj,
    onSubmit,
    setIsChangedFormValues,
    isChangedFormValues,
    loadingUpdate,
}) => {
    const [ form ] = Form.useForm();
    const translate = useTranslate();
    
    useEffect(() => {
        form.setFieldsValue({
            lateTime: settingObj?.late_time,
            groupTakeAway: !!settingObj?.group_take_away,
            groupDelivery: !!settingObj?.group_delivery,
            foodBreakCount: settingObj?.food_break_count,
        });
    }, [ settingObj, form ]);

    const handleSubmit = (values) => {
        onSubmit({
            lateTime: values.lateTime,
            groupTakeAway: values.groupTakeAway,
            groupDelivery: values.groupDelivery,
            foodBreakCount: values.foodBreakCount,
        });
    };

    const onValuesChange = () => {
        setIsChangedFormValues(true);
    };

    return (
        <Form
            id={formId}
            className="kitplay-form"
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            onValuesChange={onValuesChange}
        >
            <Row gutter={16}>
                <Col span={24}>
                    <NumericField
                        label={translate.formatMessage(commonMessage.lateTime) + ` (${translate.formatMessage(commonMessage.minute)})`}
                        name="lateTime"
                        formatter={(v) => v}
                        parser={(v) => v}
                        rules={[ { pattern: /^[0-9]+$/, message: '' } ]}
                        width="100%"
                    />
                </Col>
                <Col span={24}>
                    <NumericField
                        label={translate.formatMessage(commonMessage.foodBreakCount)}
                        name="foodBreakCount"
                        rules={[ { pattern: /^[0-9]+$/, message: '' } ]}
                        width="100%"
                    />
                </Col>
                <Col span={12}>
                    <Flex align="center" gap={12}>
                        <Form.Item
                            name="groupTakeAway"
                            valuePropName="checked"
                            noStyle
                            required
                        >
                            <Switch
                                onChange={(value) => form.setFieldsValue({ groupTakeAway: value })}
                            />
                        </Form.Item>
                        <span>{translate.formatMessage(commonMessage.groupTakeAway)}</span>
                    </Flex>
                </Col>
                <Col span={12}>
                    <Flex align="center" gap={12}>
                        <Form.Item
                            name="groupDelivery"
                            valuePropName="checked"
                            noStyle
                            required
                        >
                            <Switch
                                onChange={(value) => form.setFieldsValue({ groupDelivery: value })}
                            />
                        </Form.Item>
                        <span>{translate.formatMessage(commonMessage.groupDelivery)}</span>
                    </Flex>
                </Col>
            </Row>
            <Flex
                justify="end"
                style={{
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 10,
                    background: '#fff',
                    padding: '12px 0 8px',
                    marginTop: 12,
                    borderTop: '1px solid #f0f0f0',
                }}
            >
                <Button
                    key="submit"
                    htmlType="submit"
                    type="primary"
                    disabled={!isChangedFormValues}
                    loading={loadingUpdate}
                >
                    <SaveOutlined style={{ marginRight: '6px' }} />
                    {translate.formatMessage(commonMessage.update)}
                </Button>
            </Flex>
        </Form>
    );
};

export default KitplaySettingForm;
